function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { FocusScope } from '@react-aria/focus';
import React, { useMemo } from 'react';

/**
 * STOP - READ BEFORE USING
 *
 * The following wrapper was added to help TinyMCE modals.
 * When used with React Aria contained Focus Scope,
 * focus does not move into the TinyMCE modal.
 * This patch gets critical functionality back at
 * the cost of possibly failing accessbility.
 * This hack keeps bugfixes for TinyMCE internal.
 * If a TextEditor isn't really a valid child,
 * use the plain FocusScope from React Aria.
 */

var FocusScopeOverrideContext = /*#__PURE__*/React.createContext({
  setProps: function setProps() {}
});
export function useOverridableFocusScope() {
  return React.useContext(FocusScopeOverrideContext);
}
export function OverridableFocusScope(props) {
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    overrideProps = _React$useState2[0],
    setProps = _React$useState2[1];
  var value = useMemo(function () {
    return {
      setProps: setProps
    };
  }, [setProps]);
  return /*#__PURE__*/React.createElement(FocusScopeOverrideContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(FocusScope, _extends({}, props, overrideProps)));
}
//# sourceMappingURL=FocusScopeOverride.js.map